import { DEFAULT_ALIGNMENT as u, ALIGN_CLASSES as f, ALIGN_CLASSES_INVERSE as c } from "../../constants.js";
function E(r) {
  var l;
  r.attrs = Object.assign({}, r.attrs, {
    alignment: { default: u }
  }), (l = r.parseDOM) == null || l.forEach(function(s) {
    let t = s.getAttrs;
    s.getAttrs = (e) => {
      let a, i = {};
      return t && Object.assign(i, t(e)), e.classList.forEach((o) => {
        c[o] && (a = c[o]);
      }), a && Object.assign(i, { alignment: a }), i;
    };
  });
  let n = r.toDOM;
  return r.toDOM = (s) => {
    if (!n)
      throw new Error("must specify a toDOM method");
    let t = n(s);
    if (t.length < 2)
      throw new Error("must specify at least two elements in output spec");
    t[1] === 0 && t.splice(1, 0, {});
    let e = t[1];
    return e != null && e.class ? e.class += ` ${f[s.attrs.alignment]}` : e.class = f[s.attrs.alignment], t;
  }, r;
}
export {
  E as centerable
};
